import { Annotator } from "../../components/annotator";
import { Navbar } from "../../components/Navbar";
import { Footer } from "../../components/Footer";
import { Head } from '@inertiajs/react';

export default function Annotate(
  { image, imageUuid, annotations }:
  { image: string, imageUuid: string, annotations: Array<object> }
) {
  return (
    <>
      <Head title="Rooster Vision - Share a rooster" />
      <Navbar />
      <div className="relative pt-16 pb-32 flex content-center items-center justify-center min-h-screen-75">
        <div className="container relative mx-auto">
          <div className="items-center flex flex-wrap">
            <div className="w-full px-4 ml-auto mr-auto text-center">
              <div>
                <h1 className="text-black font-semibold text-5xl mb-10">Locate the rooster</h1>
                <h3 className="text-black font-semibold text-l mb-10">Draw a box around the rooster(s) and give it a name</h3>
                <div className="max-w-2xl px-4 mx-auto">
                  <div className="container font-bold text-4xl text-blue-500">
                    <Annotator image={image} imageUuid={imageUuid} annotations={annotations} readOnly={false} /> 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <Footer />
    </>
  );
}
